import { render, staticRenderFns } from "./product-print-on-demand.vue?vue&type=template&id=be44f35a&scoped=true&"
import script from "./product-print-on-demand.vue?vue&type=script&lang=js&"
export * from "./product-print-on-demand.vue?vue&type=script&lang=js&"
import style0 from "./product-print-on-demand.vue?vue&type=style&index=0&id=be44f35a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be44f35a",
  null
  
)

export default component.exports